export interface IInventoryItemTethering {
  tetheringId: string;
  partIdentifier: string;
  unitPrice: number;
  isActive: boolean;
}
